import { useSnackbar, type CustomContentProps } from 'notistack';
import { forwardRef, useCallback, type ForwardRefExoticComponent, type MouseEvent, type RefAttributes } from 'react';
import { useSkin } from '../../contexts/SkinContext';
import useLocalization from '../../hooks/useLocalization';
import { SKIN, type Skin } from '../../types/enums';
import LegacySnackbarContent from './snackbar/LegacySnackbarContent';
import NeobetSnackbarContent from './snackbar/NeobetSnackbarContent';
import type { StyledSnackbarContentProps } from './snackbar/types';

type SnackbarContentRenderer = ForwardRefExoticComponent<StyledSnackbarContentProps & RefAttributes<HTMLDivElement>>;

const SNACKBAR_CONTENT_RENDERERS: Partial<Record<Skin, SnackbarContentRenderer>> = {
  [SKIN.NEOBET]: NeobetSnackbarContent,
};

export const StyledSnackbar = forwardRef<HTMLDivElement, CustomContentProps>((props, ref) => {
  const { id } = props;
  const { closeSnackbar } = useSnackbar();
  const { t } = useLocalization();
  const { skin } = useSkin();
  const SnackbarContent = SNACKBAR_CONTENT_RENDERERS[skin] ?? LegacySnackbarContent;

  const handleClose = useCallback(
    (event?: MouseEvent<HTMLElement>) => {
      event?.stopPropagation();
      closeSnackbar(id);
    },
    [closeSnackbar, id]
  );

  return <SnackbarContent ref={ref} {...props} closeLabel={t('close')} onClose={handleClose} />;
});

export default StyledSnackbar;
